import { render } from "./FileAttachments.vue?vue&type=template&id=4ef374fc&scoped=true"
import script from "./FileAttachments.vue?vue&type=script&lang=js"
export * from "./FileAttachments.vue?vue&type=script&lang=js"

import "./FileAttachments.vue?vue&type=style&index=0&id=4ef374fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef374fc"]])

export default __exports__